import cx from 'classnames';
import {
    CANCEL,
    USER_STROLLERS_ADD,
    USER_STROLLERS_ADD_NEXT_STROLLER,
    USER_STROLLERS_ADD_STROLLER,
    USER_STROLLERS_CHANGE,
    USER_STROLLERS_FINISH,
    USER_STROLLERS_INIT_MESSAGE,
    USER_STROLLERS_MY_STROLLERS,
    USER_STROLLERS_SELECT_ENTER_SOME_CHARS,
    USER_STROLLERS_SELECT_NO_RESULTS,
} from 'mk/autogenerated/translations/UserStrollers.d0ae45508c0b9e406d0539dd1b2ff000'
import UserStrollerItem from 'mk2/apps/blogs/components/UserStrollerItem';
import { SuggestedStrollerOption } from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.interfaces';
import { StrollerEntity, StrollerUserReviewEntity } from 'mk2/apps/strollers/schemas';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import React from 'react';
import Select, { createFilter } from 'react-select';
import styles from './UserStrollersWidget.mscss';

export const UserStrollersWidgetMode = {
    Add: 'add' as 'add',
    Overview: 'overview' as 'overview',
};

interface OwnState {
    isListMaintained: boolean;
    activeMode: string;
    searchResultId: number;
    currentOption: any;
}

interface OwnProps {
    isAdmin: boolean;
    isOwner: boolean;
    renderBlankInit: boolean;
    reviews?: StrollerUserReviewEntity[];
    strollers?: StrollerEntity[];
    suggestedStrollerOptions: SuggestedStrollerOption[];
    username: string;
    onAddMyStroller?(strollerId: number, username: string);
    onReloadStrollerSuggestions(searchTerm: string);
    onRemoveMyStroller?(strollerId: number, username: string);
}

export class UserStrollers extends React.Component<OwnProps, OwnState> {

    private selectFiltering = createFilter({
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: 'any',
    });

    constructor(props: OwnProps) {
        super(props);
        this.state = {
            isListMaintained: false,
            activeMode: UserStrollersWidgetMode.Overview,
            searchResultId: null,
            currentOption: null,
        };
    }

    public render() {
        const {
            isAdmin, isOwner, username, strollers, reviews, suggestedStrollerOptions,
            onRemoveMyStroller,
        } =  this.props;

        const { searchResultId } = this.state;

        const canWriteReview: boolean = isOwner;
        const canMaintain: boolean = isOwner || isAdmin;
        if (!canMaintain && !(strollers && strollers.length > 0)) {
            return (
                <div className={styles.UserStrollersWidget__hide} />
            );
        }

        return (
            <div className={styles.UserStrollersWidget}>
                <div className={styles.UserStrollersWidget__header}>
                    <h2>{USER_STROLLERS_MY_STROLLERS}</h2>
                    { this.state.activeMode === UserStrollersWidgetMode.Overview && canMaintain && strollers && strollers.length > 0 && [
                        <div key="edit-finish-sep" className={styles.UserStrollersWidget__header__sep}>•</div>,
                        !this.state.isListMaintained ? (
                            <Btn
                                key="change"
                                type={BtnType.Link}
                                label={USER_STROLLERS_CHANGE}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickUserStrollerListMaintenanceStart}
                                className={styles.UserStrollersWidget__header__changeBtn}
                            />
                        ) : (
                            <Btn
                                key="finish"
                                type={BtnType.Link}
                                label={USER_STROLLERS_FINISH}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickUserStrollerListMaintenanceExit}
                                className={styles.UserStrollersWidget__header__finishBtn}
                            />
                        ),
                        ]
                    }
                </div>

                { this.state.activeMode === UserStrollersWidgetMode.Overview && (
                    <div className={styles.UserStrollersWidget__overview}>
                        { !strollers || strollers.length === 0 ? (
                            <p className={styles.UserStrollersWidget__overview__initMsg}>{USER_STROLLERS_INIT_MESSAGE}</p>
                        ) : (
                            <div className={styles.UserStrollersWidget__overview__list}>
                                {strollers.map((stroller) => (
                                    <UserStrollerItem
                                        key={stroller.id}
                                        stroller={stroller}
                                        review={
                                            reviews.filter((r) => r.stroller.slug === stroller.slug).length !== 0 ?
                                            reviews.filter((r) => r.stroller.slug === stroller.slug)[0] : undefined
                                        }
                                        username={username}
                                        canWriteReview={canWriteReview}
                                        canMaintain={this.state.isListMaintained && canMaintain}
                                        onRemoveMyStroller={onRemoveMyStroller}
                                    />
                                ))}
                            </div>
                        )}
                        { canMaintain && !this.state.isListMaintained && (
                            <Btn
                                key="add_my_stroller"
                                type={BtnType.BlueTextLight}
                                className={styles.UserStrollersWidget__overview__addBtn}
                                icon="mkicon-add@2x.png"
                                label={!strollers || strollers.length === 0 ? USER_STROLLERS_ADD_STROLLER : USER_STROLLERS_ADD_NEXT_STROLLER}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickShowMenuToAddUserStroller}
                            />
                        )}
                    </div>
                )}
                { this.state.activeMode === UserStrollersWidgetMode.Add && canMaintain && (
                    <div className={styles.UserStrollersWidget__add}>
                        <div className={styles.UserStrollersWidget__add__suggestBoxWrapper}>
                            <Select
                                placeholder={USER_STROLLERS_SELECT_ENTER_SOME_CHARS}
                                isClearable
                                isSearchable
                                onChange={this.handleChange}
                                onInputChange={this.handleInputChange}
                                options={suggestedStrollerOptions}
                                noOptionsMessage={this.getNotOptionMessage}
                                filterOption={this.filterOptions}
                                className={styles.UserStrollersWidget__add__suggestBox}
                            />
                        </div>
                        <Btn
                            className={cx(styles.MessageForm__button, styles.UserStrollersWidget__add__btn)}
                            type={BtnType.BzGreen}
                            label={USER_STROLLERS_ADD}
                            onClick={this.onClickAddUserStroller}
                            disabled={!searchResultId}
                        />
                        <Btn
                            className={styles.UserStrollersWidget__add__btn}
                            type={BtnType.Link}
                            label={CANCEL}
                            onClick={this.onClickCancelAddUserStroller}
                        />
                    </div>
                )}
            </div>
        );
    }

    public componentDidUpdate() {
        if (this.state.activeMode === UserStrollersWidgetMode.Overview) {
            const { strollers } = this.props;
            if (!strollers || strollers.length === 0) {
                if (this.state.isListMaintained) {
                    this.setState({isListMaintained: false});
                }
            }
        }
    }

    private getNotOptionMessage = (inputValue) => {
        return USER_STROLLERS_SELECT_NO_RESULTS;
    };

    private filterOptions = (candidate, input) => {
        return (input && candidate.label === '...') || this.selectFiltering(candidate, input);
    };

    private onClickUserStrollerListMaintenanceStart = () => {
        this.setState({ isListMaintained: true });
    };

    private onClickUserStrollerListMaintenanceExit = () => {
        this.setState({ isListMaintained: false });
    };

    private onClickShowMenuToAddUserStroller = () => {
        this.setState({ activeMode: UserStrollersWidgetMode.Add });
    };

    private onClickAddUserStroller = () => {
        const { onAddMyStroller } = this.props;
        if (this.state.searchResultId) {
            onAddMyStroller(this.state.searchResultId, this.props.username);
        }
        this.setState({ activeMode: UserStrollersWidgetMode.Overview });
    };

    private onClickCancelAddUserStroller = () => {
        this.setState({ activeMode: UserStrollersWidgetMode.Overview });

    };

    private handleChange = (selectedOption) => {
        this.setState({searchResultId: selectedOption ? selectedOption.value : null});
        if (!selectedOption) {
            this.props.onReloadStrollerSuggestions('');
        }
    };

    private handleInputChange = (q) => {
        this.props.onReloadStrollerSuggestions(q);
    };
}
